var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6669 6.33352C9.33345 5.22236 8.44446 3.77785 7.99996 2C6.88873 2.88893 6.33311 3.77785 6.33311 4.66678C6.33311 6.00017 7.33322 6.66686 7.33322 8.00025C7.33322 8.4423 7.15761 8.86624 6.84501 9.17881C6.53241 9.49139 6.10844 9.66699 5.66636 9.66699C5.22429 9.66699 4.80031 9.49139 4.48772 9.17881C4.17512 8.86624 3.99951 8.4423 3.99951 8.00025C3.56672 8.57726 3.33276 9.27907 3.33276 10.0003C3.33276 11.2381 3.82449 12.4251 4.69975 13.3003C5.57502 14.1755 6.76215 14.6672 7.99996 14.6672C9.23778 14.6672 10.4249 14.1755 11.3002 13.3003C12.1754 12.4251 12.6672 11.2381 12.6672 10.0003C12.6672 8.66695 12.0004 7.44467 10.6669 6.33352Z",
    stroke: "#4C6C47",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.db8e016323349144dce568f5363267cc.svg";
export { ForwardRef as ReactComponent };